import {Directive, EventEmitter, Output} from "@angular/core";
import {IntResizeObserverService} from "./resize-observer.service";
import {DestroyStreamService} from "../../services";
import {takeUntil} from "rxjs/operators";

@Directive({
  selector: '[intResizeObserver]',
  providers: [
    IntResizeObserverService,
    DestroyStreamService
  ]
})
export class IntResizeObserverDirective {
  @Output() onResize = new EventEmitter<ResizeObserverEntry[]>()
  constructor(
    private readonly ro: IntResizeObserverService,
    private readonly destroy$: DestroyStreamService
  ) {
    this.ro.observable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.onResize.next(value);
      })
  }
}
